import { z } from 'zod';
import { idSchema, projectColorSchema, softDeleteTimestampsSchema } from './common.js';
/** Clave reservada para la vista compuesta "Mis tareas": no es un proyecto real. */
export const MY_TASKS_KEY = 'TASKS';
/** Clave corta del proyecto: 3-5 caracteres, mayúsculas y dígitos. */
export const projectKeySchema = z
    .string()
    .regex(/^[A-Z0-9]{3,5}$/, 'La clave son 3-5 caracteres en mayúsculas o dígitos')
    .refine((key) => key !== MY_TASKS_KEY, 'La clave son 3-5 caracteres en mayúsculas o dígitos');
export const projectSchema = z
    .object({
    id: idSchema,
    name: z.string().min(1).max(120),
    key: projectKeySchema,
    description: z.string().max(2000).nullable(),
    color: projectColorSchema,
    isArchived: z.boolean(),
    position: z.number().int(),
})
    .extend(softDeleteTimestampsSchema.shape);
export const createProjectRequestSchema = z.object({
    name: z.string().min(1).max(120),
    key: projectKeySchema,
    description: z.string().max(2000).nullable().optional(),
    color: projectColorSchema,
});
export const updateProjectRequestSchema = z
    .object({
    name: z.string().min(1).max(120),
    key: projectKeySchema,
    description: z.string().max(2000).nullable(),
    color: projectColorSchema,
    isArchived: z.boolean(),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    message: 'Se requiere al menos un campo',
});
/** `GET /projects` */
export const listProjectsQuerySchema = z.object({
    includeArchived: z.stringbool().default(false),
    /** Papelera (CLAUDE.md §6, fase 5): mutuamente excluyente con `includeArchived`. */
    onlyDeleted: z.stringbool().default(false),
});
/** `POST /projects/reorder` — la posición es el índice dentro de la lista. */
export const reorderProjectsRequestSchema = z.object({
    orderedIds: z.array(idSchema).min(1),
});
//# sourceMappingURL=project.js.map